// extracted by mini-css-extract-plugin
export var avatar = "MarketGroup-module--avatar--ba3be";
export var blue = "#0eb3f2";
export var clamp = "MarketGroup-module--clamp--16bf2";
export var darken = "MarketGroup-module--darken--62173";
export var draw = "MarketGroup-module--draw--fbf3d";
export var emphasis = "MarketGroup-module--emphasis--7cb82";
export var franchiseLogo = "MarketGroup-module--franchiseLogo--04b68";
export var franchiseLogos = "MarketGroup-module--franchiseLogos--a78fc";
export var franchiseName = "MarketGroup-module--franchiseName--6290e";
export var green = "#57d33b";
export var greenLink = "MarketGroup-module--green-link--97b39";
export var grey = "var(--tone-mid)";
export var group = "MarketGroup-module--group--90cb0";
export var headingRight = "MarketGroup-module--headingRight--94af0";
export var headingRightGroup = "MarketGroup-module--headingRightGroup--1940a";
export var left = "MarketGroup-module--left--d17e6";
export var lock = "MarketGroup-module--lock--39aab";
export var locked = "MarketGroup-module--locked--0f5e5";
export var marketCard = "MarketGroup-module--marketCard--d95dc";
export var marketGroup = "MarketGroup-module--marketGroup--461bb";
export var markets = "MarketGroup-module--markets--9a35a";
export var name = "MarketGroup-module--name--ff15b";
export var noBorder = "MarketGroup-module--noBorder--dfc52";
export var notchGap = "32px";
export var open = "MarketGroup-module--open--49298";
export var orange = "#f8662b";
export var red = "#ff2741";
export var suspended = "MarketGroup-module--suspended--b87e5";
export var suspendedOutright = "MarketGroup-module--suspendedOutright--74a30";
export var tick = "MarketGroup-module--tick--fd2a0";
export var trigger = "MarketGroup-module--trigger--b08d2";
export var widthDesktop = "1024px";
export var widthDesktopXl = "1280px";
export var widthExpanded = "1536px";
export var widthMobile = "640px";
export var widthTablet = "768px";
export var yellow = "#ffb100";